/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
/**
 * Check if a given object implements the Lunchtime interface.
 */
export function instanceOfLunchtime(value) {
    let isInstance = true;
    isInstance = isInstance && "within" in value;
    return isInstance;
}
export function LunchtimeFromJSON(json) {
    return LunchtimeFromJSONTyped(json, false);
}
export function LunchtimeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        duration: !exists(json, "duration") ? undefined : json.duration,
        within: json.within,
    };
}
export function LunchtimeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        duration: value.duration,
        within: value.within,
    };
}
